import { render, staticRenderFns } from "./allCoursesComponent.vue?vue&type=template&id=4206c7b9&"
import script from "./allCoursesComponent.vue?vue&type=script&lang=js&"
export * from "./allCoursesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports